import { render, staticRenderFns } from "./HbTabsResponsive.vue?vue&type=template&id=5108646b&scoped=true&"
import script from "./HbTabsResponsive.vue?vue&type=script&lang=js&"
export * from "./HbTabsResponsive.vue?vue&type=script&lang=js&"
import style0 from "./HbTabsResponsive.vue?vue&type=style&index=0&id=5108646b&prod&scoped=true&lang=css&"
import style1 from "./HbTabsResponsive.vue?vue&type=style&index=1&id=5108646b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5108646b",
  null
  
)

export default component.exports